module.exports = __webpack_public_path__ + "img/pic_noOrders.1766306608134.png";